module.exports = __webpack_public_path__ + "img/15_26.add1e8fe.png";